module.exports = __webpack_public_path__ + "img/gallery-1.87140f1a.webp";